import SmallPopupDefaultTemplate from "components/templates/modal/small/SmallPopupDefaultTemplate";
import BigButton from "components/atoms/buttons/BigButton";
import { useAppSelector } from "redux/hooks";
import { ValidAuth } from "redux/reducers/auth/isAuth";
import styled from "styled-components";
import { COLORS } from "../../styles/colors";
import { calcRem } from "../../styles/theme";
import { FLEX } from "../../styles/flex";
import { useLocation } from "react-router-dom";
import { logoutAbleUrl, normalAbleUrl } from "utils/MenuUtil";
import { useAuth } from "components/Auth";

export default function SessionExpired(): JSX.Element {
  const location = useLocation();
  const { isLogout, isAuthenticated }: ValidAuth = useAppSelector(
    (state) => state.isAuth
  );

  const { onForwardLogin } = useAuth();
  if (
    !isLogout &&
    !isAuthenticated &&
    !logoutAbleUrl.includes(location.pathname) &&
    !normalAbleUrl.includes(location.pathname)
  ) {
    return (
      <SmallPopupDefaultTemplate
        button={
          <BigButton
            label="Login"
            onClickBtn={onForwardLogin}
            data-testid="element-session-expired-tsx-element-button-forward-login"
          />
        }
        disableClose
        //onModal={() => setIsOpenReLogin(false)}
      >
        <Container>
          <Title>
            Session Expired
            <br />
            <strong>
              Your session has been closed for security reasons.
              <br />
              You will be redirected to the login page.
            </strong>
          </Title>
        </Container>
      </SmallPopupDefaultTemplate>
    );
  }
  return <></>;
}
const Title = styled.div`
  font-weight: 500;
  color: ${(props) => props.theme.COLORS.WHITE};
  font-size: ${calcRem(20)};
  text-align: center;
  padding: 20px 0;
  line-height: ${calcRem(24)};
  strong {
    color: ${COLORS.COMPANY};
    font-size: ${calcRem(18)};
  }
`;
const Container = styled.div`
  max-width: 100%;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
`;
